module.exports = __webpack_public_path__ + "img/CRM.84f50467.png";